import { useSyncExternalStore } from 'react'

const KEY = 'privacy.hideAmounts'
export const AMOUNT_MASK = '•••••'

let hidden = localStorage.getItem(KEY) === '1'
const listeners = new Set<() => void>()

export function isAmountsHidden() {
  return hidden
}

export function setAmountsHidden(value: boolean) {
  hidden = value
  localStorage.setItem(KEY, value ? '1' : '0')
  listeners.forEach((l) => l())
}

export function toggleAmountsHidden() {
  setAmountsHidden(!hidden)
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function useAmountsHidden() {
  return useSyncExternalStore(subscribe, isAmountsHidden)
}
